<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M8 22c-.28 0-.52-.1-.71-.29A.973.973 0 0 1 7 21V5c0-.28.1-.52.29-.71C7.48 4.1 7.72 4 8 4h2V2h4v2h2c.28 0 .52.1.71.29.19.19.29.43.29.71v16c0 .28-.1.52-.29.71-.19.19-.43.29-.71.29H8Zm1-12h6V6H9v4Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
